import Header from "units/dashboard/components/Header";
import AdminSidebar from "./components/AdminSidebar";
import Footer from "units/dashboard/components/Footer";
import AdminDashboardInfo from "./components/AdminDashboardInfo"
const AdminDashboard = () => {

    return (
        <>

            <nav
                className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                <Header/>
            </nav>

            <div
                className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                <AdminSidebar/>
            </div>

            <div className="flex flex-col min-h-screen">
                <div className="main-content flex-grow">
                    <div className="page-content">

                        <div className="container-fluid px-[0.625rem]">

                            <div className="grid grid-cols-1 mb-2">
                                <div className="flex items-center justify-between">
                                    <h4 className="mb-sm-0 text-2xl font-semibold grow text-gray-800 ">داشبورد</h4>
                                    <nav className="flex" aria-label="Breadcrumb">

                                    </nav>
                                </div>
                            </div>
                            <h1 className="text-lg mr-2"> ادمین محترم به داشبورد کاربری خوش امدید . </h1>

                        </div>
                        <AdminDashboardInfo/>
                    </div>
                   <Footer/>
                </div>
            </div>

        </>
    );
};

export default AdminDashboard;
